/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ImportTemplates200,
  ImportTemplatesParams,
  Languages,
  MultiLanguageTemplateDTO,
  NotificationPlatforms,
  ProcessTemplateContentBody,
  ProcessTemplateSubjectBody,
  TextTemplateDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getOne = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO>(
      {url: `/api/texttemplate/${name}/${language}/${platform}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOneQueryKey = (name?: string,
    language?: Languages,
    platform?: NotificationPlatforms,) => {
    return [`/api/texttemplate/${name}/${language}/${platform}`] as const;
    }

    
export const getGetOneQueryOptions = <TData = Awaited<ReturnType<typeof getOne>>, TError = unknown>(name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneQueryKey(name,language,platform);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOne>>> = ({ signal }) => getOne(name,language,platform, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name && language && platform), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOneQueryResult = NonNullable<Awaited<ReturnType<typeof getOne>>>
export type GetOneQueryError = unknown


export function useGetOne<TData = Awaited<ReturnType<typeof getOne>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOne>>,
          TError,
          Awaited<ReturnType<typeof getOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOne<TData = Awaited<ReturnType<typeof getOne>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOne>>,
          TError,
          Awaited<ReturnType<typeof getOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOne<TData = Awaited<ReturnType<typeof getOne>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOne<TData = Awaited<ReturnType<typeof getOne>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOneQueryOptions(name,language,platform,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const update = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
    textTemplateDTO: TextTemplateDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TextTemplateDTO>(
      {url: `/api/texttemplate/${name}/${language}/${platform}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: textTemplateDTO
    },
      options);
    }
  


export const getUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: TextTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: TextTemplateDTO}, TContext> => {

const mutationKey = ['update'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update>>, {name: string;language: Languages;platform: NotificationPlatforms;data: TextTemplateDTO}> = (props) => {
          const {name,language,platform,data} = props ?? {};

          return  update(name,language,platform,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof update>>>
    export type UpdateMutationBody = TextTemplateDTO
    export type UpdateMutationError = unknown

    export const useUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: TextTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update>>,
        TError,
        {name: string;language: Languages;platform: NotificationPlatforms;data: TextTemplateDTO},
        TContext
      > => {

      const mutationOptions = getUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const _delete = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/texttemplate/${name}/${language}/${platform}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{name: string;language: Languages;platform: NotificationPlatforms}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{name: string;language: Languages;platform: NotificationPlatforms}, TContext> => {

const mutationKey = ['_delete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _delete>>, {name: string;language: Languages;platform: NotificationPlatforms}> = (props) => {
          const {name,language,platform} = props ?? {};

          return  _delete(name,language,platform,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type _DeleteMutationResult = NonNullable<Awaited<ReturnType<typeof _delete>>>
    
    export type _DeleteMutationError = unknown

    export const useDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{name: string;language: Languages;platform: NotificationPlatforms}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof _delete>>,
        TError,
        {name: string;language: Languages;platform: NotificationPlatforms},
        TContext
      > => {

      const mutationOptions = getDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const updateMultiLanguage = (
    name: string,
    platform: NotificationPlatforms,
    multiLanguageTemplateDTO: MultiLanguageTemplateDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TextTemplateDTO[]>(
      {url: `/api/texttemplate/multilanguage/${name}/${platform}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: multiLanguageTemplateDTO
    },
      options);
    }
  


export const getUpdateMultiLanguageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMultiLanguage>>, TError,{name: string;platform: NotificationPlatforms;data: MultiLanguageTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMultiLanguage>>, TError,{name: string;platform: NotificationPlatforms;data: MultiLanguageTemplateDTO}, TContext> => {

const mutationKey = ['updateMultiLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMultiLanguage>>, {name: string;platform: NotificationPlatforms;data: MultiLanguageTemplateDTO}> = (props) => {
          const {name,platform,data} = props ?? {};

          return  updateMultiLanguage(name,platform,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMultiLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof updateMultiLanguage>>>
    export type UpdateMultiLanguageMutationBody = MultiLanguageTemplateDTO
    export type UpdateMultiLanguageMutationError = unknown

    export const useUpdateMultiLanguage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMultiLanguage>>, TError,{name: string;platform: NotificationPlatforms;data: MultiLanguageTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMultiLanguage>>,
        TError,
        {name: string;platform: NotificationPlatforms;data: MultiLanguageTemplateDTO},
        TContext
      > => {

      const mutationOptions = getUpdateMultiLanguageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllTextTemplates = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO[]>(
      {url: `/api/texttemplate`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllTextTemplatesQueryKey = () => {
    return [`/api/texttemplate`] as const;
    }

    
export const getGetAllTextTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getAllTextTemplates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTextTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTextTemplates>>> = ({ signal }) => getAllTextTemplates(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllTextTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTextTemplates>>>
export type GetAllTextTemplatesQueryError = unknown


export function useGetAllTextTemplates<TData = Awaited<ReturnType<typeof getAllTextTemplates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTextTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllTextTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTextTemplates<TData = Awaited<ReturnType<typeof getAllTextTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTextTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllTextTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTextTemplates<TData = Awaited<ReturnType<typeof getAllTextTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllTextTemplates<TData = Awaited<ReturnType<typeof getAllTextTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTextTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllTextTemplatesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const create = (
    textTemplateDTO: TextTemplateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO>(
      {url: `/api/texttemplate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: textTemplateDTO, signal
    },
      options);
    }
  


export const getCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: TextTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: TextTemplateDTO}, TContext> => {

const mutationKey = ['create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof create>>, {data: TextTemplateDTO}> = (props) => {
          const {data} = props ?? {};

          return  create(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMutationResult = NonNullable<Awaited<ReturnType<typeof create>>>
    export type CreateMutationBody = TextTemplateDTO
    export type CreateMutationError = unknown

    export const useCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: TextTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof create>>,
        TError,
        {data: TextTemplateDTO},
        TContext
      > => {

      const mutationOptions = getCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const processTemplateSubject = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
    processTemplateSubjectBody: ProcessTemplateSubjectBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/texttemplate/${name}/${language}/${platform}/process-subject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processTemplateSubjectBody, signal
    },
      options);
    }
  


export const getProcessTemplateSubjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTemplateSubject>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateSubjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof processTemplateSubject>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateSubjectBody}, TContext> => {

const mutationKey = ['processTemplateSubject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processTemplateSubject>>, {name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateSubjectBody}> = (props) => {
          const {name,language,platform,data} = props ?? {};

          return  processTemplateSubject(name,language,platform,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessTemplateSubjectMutationResult = NonNullable<Awaited<ReturnType<typeof processTemplateSubject>>>
    export type ProcessTemplateSubjectMutationBody = ProcessTemplateSubjectBody
    export type ProcessTemplateSubjectMutationError = unknown

    export const useProcessTemplateSubject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTemplateSubject>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateSubjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processTemplateSubject>>,
        TError,
        {name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateSubjectBody},
        TContext
      > => {

      const mutationOptions = getProcessTemplateSubjectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const processTemplateContent = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
    processTemplateContentBody: ProcessTemplateContentBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/texttemplate/${name}/${language}/${platform}/process-content`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processTemplateContentBody, signal
    },
      options);
    }
  


export const getProcessTemplateContentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTemplateContent>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateContentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof processTemplateContent>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateContentBody}, TContext> => {

const mutationKey = ['processTemplateContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processTemplateContent>>, {name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateContentBody}> = (props) => {
          const {name,language,platform,data} = props ?? {};

          return  processTemplateContent(name,language,platform,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessTemplateContentMutationResult = NonNullable<Awaited<ReturnType<typeof processTemplateContent>>>
    export type ProcessTemplateContentMutationBody = ProcessTemplateContentBody
    export type ProcessTemplateContentMutationError = unknown

    export const useProcessTemplateContent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTemplateContent>>, TError,{name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateContentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processTemplateContent>>,
        TError,
        {name: string;language: Languages;platform: NotificationPlatforms;data: ProcessTemplateContentBody},
        TContext
      > => {

      const mutationOptions = getProcessTemplateContentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createMultiLanguage = (
    multiLanguageTemplateDTO: MultiLanguageTemplateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO[]>(
      {url: `/api/texttemplate/multilanguage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiLanguageTemplateDTO, signal
    },
      options);
    }
  


export const getCreateMultiLanguageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMultiLanguage>>, TError,{data: MultiLanguageTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createMultiLanguage>>, TError,{data: MultiLanguageTemplateDTO}, TContext> => {

const mutationKey = ['createMultiLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMultiLanguage>>, {data: MultiLanguageTemplateDTO}> = (props) => {
          const {data} = props ?? {};

          return  createMultiLanguage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMultiLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof createMultiLanguage>>>
    export type CreateMultiLanguageMutationBody = MultiLanguageTemplateDTO
    export type CreateMultiLanguageMutationError = unknown

    export const useCreateMultiLanguage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMultiLanguage>>, TError,{data: MultiLanguageTemplateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMultiLanguage>>,
        TError,
        {data: MultiLanguageTemplateDTO},
        TContext
      > => {

      const mutationOptions = getCreateMultiLanguageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const importTemplates = (
    textTemplateDTO: TextTemplateDTO[],
    params?: ImportTemplatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportTemplates200>(
      {url: `/api/texttemplate/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: textTemplateDTO,
        params, signal
    },
      options);
    }
  


export const getImportTemplatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTemplates>>, TError,{data: TextTemplateDTO[];params?: ImportTemplatesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importTemplates>>, TError,{data: TextTemplateDTO[];params?: ImportTemplatesParams}, TContext> => {

const mutationKey = ['importTemplates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTemplates>>, {data: TextTemplateDTO[];params?: ImportTemplatesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importTemplates(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof importTemplates>>>
    export type ImportTemplatesMutationBody = TextTemplateDTO[]
    export type ImportTemplatesMutationError = unknown

    export const useImportTemplates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTemplates>>, TError,{data: TextTemplateDTO[];params?: ImportTemplatesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTemplates>>,
        TError,
        {data: TextTemplateDTO[];params?: ImportTemplatesParams},
        TContext
      > => {

      const mutationOptions = getImportTemplatesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getTemplateSubject = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/texttemplate/${name}/${language}/${platform}/subject`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTemplateSubjectQueryKey = (name?: string,
    language?: Languages,
    platform?: NotificationPlatforms,) => {
    return [`/api/texttemplate/${name}/${language}/${platform}/subject`] as const;
    }

    
export const getGetTemplateSubjectQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateSubject>>, TError = unknown>(name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateSubjectQueryKey(name,language,platform);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateSubject>>> = ({ signal }) => getTemplateSubject(name,language,platform, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name && language && platform), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTemplateSubjectQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateSubject>>>
export type GetTemplateSubjectQueryError = unknown


export function useGetTemplateSubject<TData = Awaited<ReturnType<typeof getTemplateSubject>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateSubject>>,
          TError,
          Awaited<ReturnType<typeof getTemplateSubject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTemplateSubject<TData = Awaited<ReturnType<typeof getTemplateSubject>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateSubject>>,
          TError,
          Awaited<ReturnType<typeof getTemplateSubject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTemplateSubject<TData = Awaited<ReturnType<typeof getTemplateSubject>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTemplateSubject<TData = Awaited<ReturnType<typeof getTemplateSubject>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateSubject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTemplateSubjectQueryOptions(name,language,platform,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTemplateContent = (
    name: string,
    language: Languages,
    platform: NotificationPlatforms,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/texttemplate/${name}/${language}/${platform}/content`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTemplateContentQueryKey = (name?: string,
    language?: Languages,
    platform?: NotificationPlatforms,) => {
    return [`/api/texttemplate/${name}/${language}/${platform}/content`] as const;
    }

    
export const getGetTemplateContentQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateContent>>, TError = unknown>(name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateContentQueryKey(name,language,platform);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateContent>>> = ({ signal }) => getTemplateContent(name,language,platform, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name && language && platform), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTemplateContentQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateContent>>>
export type GetTemplateContentQueryError = unknown


export function useGetTemplateContent<TData = Awaited<ReturnType<typeof getTemplateContent>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateContent>>,
          TError,
          Awaited<ReturnType<typeof getTemplateContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTemplateContent<TData = Awaited<ReturnType<typeof getTemplateContent>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateContent>>,
          TError,
          Awaited<ReturnType<typeof getTemplateContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTemplateContent<TData = Awaited<ReturnType<typeof getTemplateContent>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTemplateContent<TData = Awaited<ReturnType<typeof getTemplateContent>>, TError = unknown>(
 name: string,
    language: Languages,
    platform: NotificationPlatforms, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTemplateContentQueryOptions(name,language,platform,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const exportTemplates = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO[]>(
      {url: `/api/texttemplate/export`, method: 'GET', signal
    },
      options);
    }
  

export const getExportTemplatesQueryKey = () => {
    return [`/api/texttemplate/export`] as const;
    }

    
export const getExportTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof exportTemplates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTemplates>>> = ({ signal }) => exportTemplates(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof exportTemplates>>>
export type ExportTemplatesQueryError = unknown


export function useExportTemplates<TData = Awaited<ReturnType<typeof exportTemplates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTemplates>>,
          TError,
          Awaited<ReturnType<typeof exportTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportTemplates<TData = Awaited<ReturnType<typeof exportTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTemplates>>,
          TError,
          Awaited<ReturnType<typeof exportTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportTemplates<TData = Awaited<ReturnType<typeof exportTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportTemplates<TData = Awaited<ReturnType<typeof exportTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportTemplatesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getByName = (
    name: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TextTemplateDTO[]>(
      {url: `/api/texttemplate/by-name/${name}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetByNameQueryKey = (name?: string,) => {
    return [`/api/texttemplate/by-name/${name}`] as const;
    }

    
export const getGetByNameQueryOptions = <TData = Awaited<ReturnType<typeof getByName>>, TError = unknown>(name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetByNameQueryKey(name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getByName>>> = ({ signal }) => getByName(name, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getByName>>>
export type GetByNameQueryError = unknown


export function useGetByName<TData = Awaited<ReturnType<typeof getByName>>, TError = unknown>(
 name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getByName>>,
          TError,
          Awaited<ReturnType<typeof getByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetByName<TData = Awaited<ReturnType<typeof getByName>>, TError = unknown>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getByName>>,
          TError,
          Awaited<ReturnType<typeof getByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetByName<TData = Awaited<ReturnType<typeof getByName>>, TError = unknown>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetByName<TData = Awaited<ReturnType<typeof getByName>>, TError = unknown>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetByNameQueryOptions(name,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteAllLanguages = (
    name: string,
    platform: NotificationPlatforms,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/texttemplate/${name}/${platform}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAllLanguagesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllLanguages>>, TError,{name: string;platform: NotificationPlatforms}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAllLanguages>>, TError,{name: string;platform: NotificationPlatforms}, TContext> => {

const mutationKey = ['deleteAllLanguages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAllLanguages>>, {name: string;platform: NotificationPlatforms}> = (props) => {
          const {name,platform} = props ?? {};

          return  deleteAllLanguages(name,platform,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAllLanguagesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAllLanguages>>>
    
    export type DeleteAllLanguagesMutationError = unknown

    export const useDeleteAllLanguages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllLanguages>>, TError,{name: string;platform: NotificationPlatforms}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAllLanguages>>,
        TError,
        {name: string;platform: NotificationPlatforms},
        TContext
      > => {

      const mutationOptions = getDeleteAllLanguagesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    